"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable react-hooks/exhaustive-deps */
var luxon_1 = require("luxon");
var react_1 = require("react");
var recharts_1 = require("recharts");
var styled_components_1 = __importDefault(require("styled-components"));
var ChartContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  width: 99%; // So the Chart resizes correctly\n  overflow: hidden;\n"], ["\n  display: flex;\n  width: 99%; // So the Chart resizes correctly\n  overflow: hidden;\n"])));
var Chart = function (_a) {
    var timestampList = _a.timestampList;
    var _b = __read(react_1.useState([]), 2), chartData = _b[0], setChartData = _b[1];
    var getChartData = function () {
        var output = {};
        if (timestampList.length === 0)
            return;
        var sorted = __spread(timestampList).sort();
        var _a = __read(sorted, 1), firstDay = _a[0];
        var startOfFirstDay = luxon_1.DateTime.fromMillis(firstDay)
            .startOf('day')
            .toMillis();
        var endOfToday = luxon_1.DateTime.now().endOf('day').toMillis();
        var datecounter = startOfFirstDay;
        while (datecounter < endOfToday) {
            output[luxon_1.DateTime.fromMillis(datecounter).toFormat('dd.LL.yyyy')] = 0;
            datecounter = datecounter + 1000 * 60 * 60 * 24;
        }
        sorted.forEach(function (request) {
            var date = luxon_1.DateTime.fromMillis(request).toFormat('dd.LL.yyyy');
            output[date] = (output[date] || 0) + 1;
        });
        var mapped = Object.entries(output).map(function (_a) {
            var _b = __read(_a, 2), date = _b[0], Anfragen = _b[1];
            return ({
                date: date,
                Anfragen: Anfragen
            });
        });
        setChartData(mapped);
    };
    react_1.useEffect(function () {
        getChartData();
    }, [timestampList]);
    return (jsx_runtime_1.jsx(ChartContainer, { children: jsx_runtime_1.jsx(recharts_1.ResponsiveContainer, __assign({ height: 600, width: "100%" }, { children: jsx_runtime_1.jsxs(recharts_1.AreaChart, __assign({ data: chartData, margin: { top: 30, right: 30, left: -30, bottom: 40 } }, { children: [jsx_runtime_1.jsx("defs", { children: jsx_runtime_1.jsxs("linearGradient", __assign({ id: "colorAnfragen", x1: "0", y1: "0", x2: "0", y2: "1" }, { children: [jsx_runtime_1.jsx("stop", { offset: "5%", stopColor: "rgb(255, 192, 0)", stopOpacity: 0.8 }, void 0),
                                jsx_runtime_1.jsx("stop", { offset: "95%", stopColor: "rgb(255, 192, 0)", stopOpacity: 0 }, void 0)] }), void 0) }, void 0),
                    jsx_runtime_1.jsx(recharts_1.XAxis, { dataKey: "date", angle: -35, dx: -33, dy: 18, tickSize: 15 }, void 0),
                    jsx_runtime_1.jsx(recharts_1.YAxis, {}, void 0),
                    jsx_runtime_1.jsx(recharts_1.Tooltip, { cursor: { stroke: 'black', strokeWidth: 1 } }, void 0),
                    jsx_runtime_1.jsx(recharts_1.CartesianGrid, { strokeDasharray: "3 3" }, void 0),
                    jsx_runtime_1.jsx(recharts_1.Area, { type: "monotone", dataKey: "Anfragen", stroke: "rgb(255, 192, 0)", fillOpacity: 1, fill: "url(#colorAnfragen)" }, void 0)] }), void 0) }), void 0) }, void 0));
};
exports.default = Chart;
var templateObject_1;
//# sourceMappingURL=Chart.js.map